import { RegisterNotification } from "../../models/types/setting";
import HttpClient from "../httpClient";

class SettingService {
    private http = HttpClient

    async registerNotification(body: RegisterNotification) {
        const response = await this.http.post("/notification/device/register", body)
        return response
    }

    async unregisterNotification(deviceId: string) {
        const response = await this.http.post("/notification/device/unregister?deviceId=" + deviceId)
        return response
    }
}

const settingService = new SettingService()

export default settingService
